import { CONSTANTS } from "@data"

const { SUBMIT, SUBMIT_PROGRESS } = CONSTANTS

export const isDone = val => {
  return SUBMIT_PROGRESS.indexOf(val) === SUBMIT_PROGRESS.indexOf(SUBMIT.SUCCESS)
}

export const submitProgress = val => {
  return SUBMIT_PROGRESS.indexOf(val) > 1
}

export const shouldDisable = val => {
  const res = submitProgress(val)
  return !!res
}
